'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'my_trips',
    viewClass: require('./view'),
    modelClass: require('./model'),

    methods: {
        showGtBannerNoBookings() {
            this._showGtBannerNoBookings();
        },
        getMyTripsOk(data) {
            this._loadTrips(data);
        },
        showManageMyBookingBox(hasRedirect = false, page) {
            this.showManageMyBookingBox(hasRedirect, page);
        },
        loadOpenBookingDetails(product) {
            this._loadOpenBookingDetails(product);
        },
        dispatchSeatMapCheckInAction(...args) {
            this.dispatchSeatMapCheckInAction(...args);
        },
        dispatchProductCheckInAction(...args) {
            this.dispatchProductCheckInAction(...args);
        },
        openLightBoxMsg(data) {
            this.openLightBoxMsg(data);
        },
        executeCheckinFunnelMethod() {
            this.checkin.execute.apply(this, arguments);
        },
        executeCheckinMoreInfoFunnelMethod(show) {
            this.checkinMoreInfo.execute('showCheckinMoreInfo', show);
        },
        /* Tripdetails & SMT */
        makeProductTabVisible(product) {
            if (Odigeo.Utils.isDesktop()) {
                this.makeProductTabVisible(product);
            }
        },
        hideWaitingPage() {
            this.toggleWaitingPageVisibility(false);
        },
        setTripCardCheckInButtonVisibility(shouldBeHidden) {
            this.setTripCardCheckInButtonVisibility(shouldBeHidden);
        },
        openRetryLink() {
            this.openRetryLink();
        },
        startCheckinFunnelPopup() {
            this.startCheckinFunnelPopup();
        },
        goToManageMyBookingPage(data) {
            this.goToManageMyBookingPage(data);
        },
        getBookingDetailsForMyTripsItineraryStatusTracking(callback) {
            callback(this.getBookingDetailsForMyTripsItineraryStatusTracking());
        },
        hideFlightStatusMessage() {
            this.hideFlightStatusMessage();
        },
        showFlightStatusMessage() {
            this.showFlightStatusMessage();
        },
        showMembershipHotelBanner() {
            this.showMembershipHotelBanner();
        },
        setIsPrimeUser(isPrimeUser) {
            this.setIsPrimeUser(isPrimeUser);
        },
        setPrimeExpirationDate(primeExpirationDate) {
            this.setPrimeExpirationDate(primeExpirationDate);
        },
        toggleDownloadAppNotification() {
            this.toggleDownloadAppNotificationLightbox();
        },
        hideTripStatusCard() {
            this.hideTripStatusCard();
        },
        hideAncillaryCTA(type) {
            this.hideAncillaryCTA(type);
        },
        displayPostBookingSeatsOF2Wrapper() {
            this.displayPostBookingSeatsOF2Wrapper();
        },
        scrollToProduct(product) {
            this.scrollToProduct(product);
        },
        checkinScenario(scenario) {
            this.loadCheckinScenario(scenario);
        },
        closeCheckinFunnel() {
            this.closeCheckinFunnel();
        },
        closeCheckinFunnelOF2() {
            this.closeCheckinFunnelOF2();
        },
        navigateToNewMMB() {
            this.navigateToNewMMB();
        },
        navigateToMMBCancellationsHSA() {
            this.navigateToMMBCancellationsHSA();
        },
        confirmationBackup() {
            this._confirmationBackup();
        },
        openNewAlternativesFlow() {
            this.openNewAlternativesFlow();
        },
        toggleWaitingPageVisibility(isOpened) {
            this.toggleWaitingPageVisibility(isOpened);
        },
        openMmbOf1() {
            this.openMmbOf1();
        },
        openMmbOf2() {
            this.openMmbOf2();
        },
        openPopupStartup(product) {
            this.openPopupStartup(product);
        },
        showBagsAndSeatsMoreInfoLink(bagsAndSeatsLoaded) {
            this.showBagsAndSeatsMoreInfoLink(bagsAndSeatsLoaded);
        },
        openBagsAndSeatsPopup({product}) {
            this.openBagsAndSeatsPopup({product});
        },
        openTripCheckinFunnelPopup() {
            this.openTripCheckinFunnelPopup();
        },
    },
});
